import { Box, Button, Dialog, DialogContent, DialogContentText } from "@mui/material";
import React from "react";

interface ConfirmationDialogComponentProps {
    message: string;
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

class ConfirmationDialogComponent extends React.Component<ConfirmationDialogComponentProps> {

    handleClose = () => {
        this.props.onClose();
    };

    handleConfirmDialog = () => {
        this.props.onConfirm();
    };

    render() {
        const { open, message } = this.props;
        return (
            < Dialog open={open} onClose={this.handleClose} >
                <DialogContent sx={{
                    padding: '0px 20px',
                    paddingTop: '25px',
                    paddingBottom: '35px',
                    textAlign: 'center',
                }}>
                    <DialogContentText sx={{ textAlign: 'center', mt: 1, mb: 3, fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.7)' }}>
                        {message}
                    </DialogContentText>
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, height: '30px' }}>
                        <Button
                            variant="contained"
                            sx={{
                                px: 4,
                                borderRadius: '6px',
                            }}
                            onClick={() => this.handleConfirmDialog()}
                        >
                            Yes
                        </Button>
                        <Button
                            onClick={this.handleClose}
                            sx={{
                                color: '#007bff',
                                borderColor: '#007bff',
                                border: '0.5px solid #53494987',
                                px: 4,
                                borderRadius: '6px',
                                '&:hover': {
                                    borderColor: '#0056b3',
                                    color: '#0056b3',
                                },
                            }}
                        >
                            No
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog >
        );
    }
}

export default ConfirmationDialogComponent;